import React, { useCallback, useState } from 'react';

import { CloseOutlined as CloseIcon } from '@ant-design/icons';
import { Button } from 'antd';

import logoMyEduzz from 'components/Icon/images/app-eduzz-logo.png';
import { isIOS } from 'v2/helpers/isIOS';
import { useIsAppWebview } from 'v2/hooks/useIsAppWebview';

const AppAlert = () => {
  const [open, setOpen] = useState<boolean>(true);
  const isAppWebview = useIsAppWebview();

  const goToApp = () => {
    if (isIOS())
      return window.open('https://apps.apple.com/br/app/eduzz-neg%C3%B3cios-digitais/id1079845439', '_blank');

    return window.open('https://play.google.com/store/apps/details?id=com.eduzzmobile.mobile', '_blank');
  };

  const onClose = useCallback<React.MouseEventHandler<HTMLButtonElement | HTMLElement>>(e => {
    e.stopPropagation();
    return setOpen(false);
  }, []);

  if (!open || isAppWebview) return null;

  return (
    <div className='block md:hidden'>
      <div
        className='fixed bottom-0 z-10 flex w-full items-center justify-between bg-[#00000088] p-3 backdrop-blur-sm'
        onClick={goToApp}
      >
        <div className='flex items-center'>
          <Button
            type='text'
            shape='circle'
            icon={<CloseIcon />}
            className='z-[99999] mr-[5px] p-0 text-white!'
            onClick={onClose}
          />
          <img src={logoMyEduzz} alt='APP Órbita' className='h-[45px] w-[45px] rounded-sm' />
          <div className='px-[10px] py-0 align-middle'>
            <p className='m-0 mb-0! text-sm font-semibold text-white'>Toque e experimente o App Eduzz!</p>
            <p className='m-0 mb-0! text-xs text-white'>A gestão do seu negócio, na palma da mão.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppAlert;
